import { ArrowRightAlt } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import AsyncImage from 'components/AsyncImage';

type Props = {
	featured: HomeFeatured;
};

function Featured({ featured }: Props) {
	return (
		<Box
			sx={{
				position: 'relative',
				width: 343,
				height: 140,
				overflow: 'hidden',
				borderRadius: 2,
			}}
		>
			<AsyncImage
				id={featured.image}
				style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				alt={featured.title.es}
			/>
			<Box
				sx={{
					position: 'absolute',
					inset: 0,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'flex-start',
					gap: 1.5,
					p: 3,
					color: 'common.white',
					backgroundImage: 'linear-gradient(90deg, rgba(6,6,53,0.9) 0%, rgba(6,6,53,0.6) 40%, rgba(0,0,0,0) 100%)',
				}}
			>
				<Typography variant="h5" component="div" sx={{ fontWeight: 700, textTransform: 'uppercase', lineHeight: 1.1 }}>
					{featured.title.es}
				</Typography>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Typography
						variant="subtitle1"
						component="span"
						sx={{ color: '#D8FF00', textDecoration: 'underline', fontWeight: 600 }}
					>
						{featured.linkText.es}
					</Typography>
					<ArrowRightAlt sx={{ color: '#D8FF00' }} />
				</Box>
			</Box>
		</Box>
	);
}

export default Featured;
